export const PRICING_CARD_DISCOUNT = {
  creator: {
    code: 'RASK35',
    year: 0.35,
  },
  creator_pro: {
    code: 'RASK35',
    year: 0.35,
  },
};
